import { Button } from "primereact/button";
import PageTitle from "../components/common/PageTitle";
import TabHeader from "../components/common/TabHeader";
import { Divider } from "primereact/divider";
import { Outlet } from "react-router-dom";
import { Dropdown } from "primereact/dropdown";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useAppContext } from "../providers/ProviderAppContainer";
import Loading from "../components/common/Loading";
import NoContent from "../components/common/NoContent";
import DialogAddBatch from "../components/manage_batches/DialogAddBatch";
import { AUTHORITIES } from "../constants";
import HasRequiredAuthority from "../components/dependencies/HasRequiredAuthority";
import { TEXT_NORMAL } from "../style";

export default function ManageBatches() {
    const { requestAPI } = useAppContext();

    const [loading, setLoading] = useState();
    const [error, setError] = useState();
    const [batches, setBatches] = useState();
    const [branchFilterId, setBranchFilterId] = useState(null);

    const [dialogAddBatch, setDialogAddBatch] = useState({
        visible: false,
    });

    const branchOptions = useMemo(() => {
        const branches = new Map();
        batches?.forEach(({ branch_id, branch_title }) => {
            if (branch_id && !branches.has(branch_id)) {
                branches.set(branch_id, { id: branch_id, title: branch_title || `Branch ${branch_id}` });
            }
        });
        return [{ id: null, title: "All Branches" }, ...branches.values()];
    }, [batches]);

    const filteredBatches = useMemo(
        () => (branchFilterId ? batches?.filter(({ branch_id }) => branch_id === branchFilterId) : batches),
        [batches, branchFilterId],
    );

    const closeDialogAddBatch = useCallback(() => {
        setDialogAddBatch((prev) => ({ ...prev, visible: false }));
    }, []);

    useEffect(() => {
        requestAPI({
            requestPath: `batches`,
            requestMethod: "GET",
            setLoading: setLoading,
            onRequestStart: setError,
            onRequestFailure: setError,
            onResponseReceieved: (batches, responseCode) => {
                if (batches && responseCode === 200) {
                    setBatches(batches);
                } else {
                    setError("Couldn't load Batches");
                }
            },
        });
    }, [requestAPI]);

    return (
        <div className="flex flex-column h-full overflow-hidden">
            <PageTitle title={`Batches`} />
            <TabHeader
                className={"px-3 pt-3"}
                title="Manage Batches"
                highlights={[`Add / Edit / Delete Batches`, `Green = Active, Red = Inactive`]}
                actionItems={[
                    <HasRequiredAuthority requiredAuthority={AUTHORITIES.CREATE_BATCH}>
                        <Button
                            icon="pi pi-plus"
                            severity="warning"
                            onClick={() => setDialogAddBatch((prev) => ({ ...prev, setBatches, visible: true, closeDialog: closeDialogAddBatch }))}
                        />
                    </HasRequiredAuthority>,
                ]}
            />
            <Divider />
            {loading ? (
                <Loading />
            ) : error ? (
                <NoContent error={error} />
            ) : (
                <>
                    {branchOptions?.length > 1 ? (
                        <div className="px-3 pb-2 flex-shrink-0">
                            <Dropdown
                                className="w-full"
                                value={branchFilterId}
                                options={branchOptions}
                                optionLabel="title"
                                optionValue="id"
                                placeholder="All Branches"
                                onChange={(e) => setBranchFilterId(e.value)}
                                pt={{ input: { className: TEXT_NORMAL }, item: { className: TEXT_NORMAL } }}
                            />
                        </div>
                    ) : null}
                    <Outlet context={{ batches: filteredBatches, setBatches }} />
                </>
            )}

            {dialogAddBatch?.visible && <DialogAddBatch {...dialogAddBatch} />}
        </div>
    );
}
